// extracted by mini-css-extract-plugin
export default {"form":"SearchRecipe_form__V0UQE"};